import React, { Fragment, useState } from 'react'
import { Table } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { RemoveCourseModal } from './RemoveCourseModal'

export const ContextCoursesTable = props => {
  const [removeCourseModalOpen, toggleModal] = useState(false)
  const [contextCourseModalObject, setContextCourseModalObject] = useState({
    title: '',
    coursenum: '',
  })

  const openModal = ccc => {
    setContextCourseModalObject(ccc)
    toggleModal(true)
  }

  return (
    <Fragment>
      <Table striped bordered className="table-sm" hover>
        <thead>
          <tr>
            <th>Created</th>
            <th>Coursenum</th>
            <th>Course Title</th>
            <th>Book Title</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {props.context.connectedCourses.map((contextCourse, i) => (
            <tr key={i}>
              <td>{contextCourse.createDate}</td>
              <td>
                <a href={`/instructor/people/${contextCourse.coursenum}`}>
                  {contextCourse.coursenum}
                </a>
              </td>
              <td className="maxw-400px">
                <a href={`/instructor/setup/${contextCourse.coursenum}`}>
                  {contextCourse.courseTitle}
                </a>
              </td>
              <td>
                <a href={`/reader/web/${contextCourse.coursenum}`}>
                  {contextCourse.title}
                </a>
              </td>
              <td>
                <a
                  onClick={() => openModal(contextCourse)}
                  className="btn btn-sm btn-sm-myed btn-danger"
                >
                  Remove <i className="fa-regular fa-window-close" />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <RemoveCourseModal
        contextCourse={contextCourseModalObject}
        show={removeCourseModalOpen}
        toggle={toggleModal}
      />
    </Fragment>
  )
}

ContextCoursesTable.propTypes = {
  context: PropTypes.object.isRequired,
}
